// Package imports:
import React, { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Style imports:
// import './AddBookmark.scss';
// Component imports:
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// Service imports:
// Action imports:
import { addBookmark } from '../../redux-store/actions/bookmarkActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';

interface IOwnProps {
    symbol: string
};
type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps & IOwnProps;

const AddBookmark: React.FC<Props> = ({
    symbol,
    selectedTick,
    accessTokenV2,
    addBookmark
}) => {
    const [ comment, setComment ] = useState('');

    const handleClick = () => {
        if (selectedTick !== null && selectedTick.timestamp !== null && comment !== '') {
            addBookmark(symbol, selectedTick.timestamp, comment, accessTokenV2);
            setComment('');
        }
    }

    const displayButton = () => {
        const canAddBookmark = (selectedTick !== null && selectedTick.timestamp !== null && comment !== '');
        if (canAddBookmark) {
            return (
                <Button
                    variant='dark'
                    size='sm'
                    onClick={handleClick}
                >
                    Save
                </Button>
            );
        } else {
            return (
                <OverlayTrigger
                    rootClose
                    delay={{ show: 100, hide: 100 }}
                    trigger={['hover', 'focus']}
                    placement='bottom'
                    overlay={(
                        <Tooltip id='AddBookmarkTooltip'>
                            To add a bookmark, select a tick and write a comment.
                        </Tooltip>
                    )}
                >
                    <span className='OverlayButtonWrapper'>
                        <Button
                            disabled
                            variant='dark'
                            size='sm'
                        >
                            Save
                        </Button>
                    </span>
                </OverlayTrigger>
            );
        }
    }

    return (
        <div id='AddBookmark'>
            <h5>Add Bookmark:</h5>
            <Form.Control
                id='BookmarkCommment'
                placeholder='Type comment'
                value={comment}
                onChange={e => setComment(e.target.value)}
            />
            {displayButton()}
        </div>
    );
}

function mapStateToProps({ dashboardReducer, loginReducer }: RootState) {
    const { selectedTick } = dashboardReducer;
    const { accessTokenV2 } = loginReducer;
    return {
        selectedTick,
        accessTokenV2
    };
}

const connector = connect(mapStateToProps, { addBookmark });
export default connector(AddBookmark);
